import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ChannelGroup from '../ChannelGroup';
import ListItem from '../ListItem';

const BROADCAST_ICON = <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'>
  <path fill='#AB9BA9' d='M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z' />
</svg>;

const Broadcasts = ({
  createNewBroadcast,
  broadcasts,
  channelsWithNewMessages,
  onChannelSelect,
  activeChannelId,
  ...props
}) => {
  return (
    <ChannelGroup
      groupTitle='Broadcasts'
      tooltip='Create a Broadcast'
      onGroupTitleClick={() => {}}
      createChannel={createNewBroadcast}
      showNewChannelButton={props.adminAtSelectedCenter}
    >
      { broadcasts.map(broadcast => {
        const { id, name } = broadcast;

        return (
          <ListItem
            isActive={activeChannelId === id}
            showBadge={false}
            messageCount={channelsWithNewMessages[id] || 0}
            key={`channel-${id}`}
            onClick={() => onChannelSelect(id, broadcast)}
          >{BROADCAST_ICON} {name}</ListItem>
        );
      })}
    </ChannelGroup>
  );
};

Broadcasts.propTypes = {
  createNewBroadcast: PropTypes.func,
  broadcasts: PropTypes.array,
  onChannelSelect: PropTypes.func,
  channelsWithNewMessages: PropTypes.object,
  activeChannelId: PropTypes.string
};

const mapStateToProps = state => ({
  adminAtSelectedCenter: state.identity.centers.filter(center => parseInt(center.id, 10) === parseInt(state.identity.centerId, 10))[0].permissions.admin
});

export default connect(mapStateToProps, null)(Broadcasts);
